import React, { useEffect } from "react";
import AppHeader from "../components/reusable/header";
import Footer from "../components/reusable/footer";
import {
  LegalMainDiv,
  LegalHeroSection,
  LegalContent
} from "../styles/legal";

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalMainDiv>
      <AppHeader
        hideContact={false}
        logo={"/images/sixthWhiteIcon.png"}
        top="0.5rem"
        width="10rem"
        mobileWidth="8rem"
      />
      
      <LegalHeroSection>
        <h1>Terms of Service</h1>
        <p>Last updated: July 15, 2026</p>
      </LegalHeroSection>

      <LegalContent>
        <p>
          These Terms of Service ("Terms") constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and SixHq Inc., doing business as Sixth ("Sixth," "we," "us," or "our"), concerning your access to and use of the Sixth website and products, including our VS Code extension.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using our services, you agree to be bound by these Terms. If you do not agree with all of these Terms, then you are expressly prohibited from using the services and must discontinue use immediately.
        </p>

        <h2>2. User Registration</h2>
        <p>
          You may be required to register with the service. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.
        </p>

        <h2>3. Intellectual Property Rights</h2>
        <p>
          Unless otherwise indicated, the service and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by SixHq Inc., its licensors, or other providers of such material and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
        </p>

        <h2>4. Prohibited Activities</h2>
        <p>
          You may not access or use the service for any purpose other than that for which we make the service available. The service may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.
        </p>
        <p>
          As a user of the service, you agree not to:
        </p>
        <ul>
          <li>Systematically retrieve data or other content from the service to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
          <li>Make any unauthorized use of the service, including collecting usernames and/or email addresses of users by electronic or other means.</li>
          <li>Circumvent, disable, or otherwise interfere with security-related features of the service.</li>
          <li>Engage in unauthorized framing of or linking to the service.</li>
        </ul>

        <h2>5. Termination</h2>
        <p>
          We may terminate or suspend your account and bar access to the service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, loss of data, or other damages arising from your use of the service, even if we have been advised of the possibility of such damages.
        </p>

        <h2>7. Disclaimer</h2>
        <p>
          The service is provided on an "as-is" and "as-available" basis. You agree that your use of the service and our services will be at your sole risk. To the fullest extent permitted by law, we disclaim all warranties, express or implied, in connection with the service and your use thereof, including, without limitation, the implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          In order to resolve a complaint regarding the service or to receive further information regarding use of the service, please contact us at: <a href="mailto:ope@trysixth.com">ope@trysixth.com</a>.
        </p>
      </LegalContent>

      <Footer />
    </LegalMainDiv>
  );
};

export default TermsOfService;
